import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import InputUI from '../../../components/UI/InputUI';
import ScannerCode from '../../../components/UI/ScannerCode';
import ReceiptList from '../Receipt/ReceiptList';
import { isNullOrEmpty, translate, getDefaultPrint, showMessageToastCustom, convertToSeparator, newObj, configs } from '../../../utils/util'
import { ENUMS, VISIONS } from '../../../utils/constants';
import Select from '../../../components/UI/Select';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import { Button } from '../../../components/UI/ComponentsUI';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import useStateWithPromise from '../../../utils/useEffectUpdate';
import { getVision } from '../../../services/auth';
import { endProcessing, startLoading } from '../../../actions/loadingAction';
import ButtonsInfo from '../Receipt/ButtonsInfo';

const SmallPartsSearch = (props) => {
    const automaticPrint = props.sheds ? props.sheds.find((i) => i.id === props.user.shed)?.automaticPrint : false;
    const [receipts, setReceipts] = useState([]);
    const [receipt, setReceipt] = useState();
    const [checked, setChecked] = useState();
    const [filter, setFilter] = useStateWithPromise({
        shed: props.user.shed,
        journey: props.physicalConfirmation?.journey,
        qrCode: '',
        notFinished: true,
        pending: true,
        partNumber: '',
        automaticPrint: automaticPrint,
        invoice: '',
        qmeLabel: '',
        mdrLabel: '',
        confirmLabel: false,
        print: getDefaultPrint(getVision()),
        resourceId: props.user?.resource || '',
    });

    useEffect(() => {
        return () => {
            setReceipts([]);
            setReceipt();
            props.resetReceipsGroup();
        }
        // eslint-disable-next-line
    }, []);


    const clearReceiptsGroup = () => {
        setReceipts([]);
        setReceipt();
        props.resetReceipsGroup();
    }

    const confirmationSmallParts = (parts) => {
        parts.forEach(x => {
            const receipt = props.receipts?.find((r) => r.partNumberCode === x);
            if (receipt) {
                if (!receipts.includes(receipt)) {
                    receipts.push(receipt);
                }
            }
        });

        setReceipts([...receipts]);
        document.getElementById("qrCode").value = "";
    }


    const handleOnKeyDown = (e) => {
        if (e.key === 'Enter') {
            changePartNumberQrCode(e.target.value);
        }
    }


    const callbackSearch = () => {
        props.resetReceipsGroup();
        var shed = !Boolean(configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items).shedRequiredPhysicalConfirmation) || props.filter?.truckKanban ? "" : props.sheds.find((i) => i.id === props.user.shed)?.code;
        if (getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD && (!isNullOrEmpty(props.physicalConfirmation?.mvmNumber) || !isNullOrEmpty(props.physicalConfirmation?.journey || props.receiptIds.length > 0))) {
            let filterDto = {
                mvmNumber: props.filter.mvmNumber,
                journey: props.filter.journey,
                supplier: props.filter.supplier,
                invoice: props.filter.invoice,
                truckKanban: props.filter?.truckKanban,
                shed: shed,
                dock: !props.filter?.truckKanban ? props.user.dock : '',
                pending: true,
                receiptIds: props.receiptIds
            }
            props.showLoading("Atualizando...");
            props.searchPhysicalConfirmationService(filterDto, () => {
                props.hideLoading();
            });
        } else {
            props.hideLoading();
        }
    }

    const changePartNumberQrCode = (value) => {
        if (!isNullOrEmpty(value)) {
            if (checked) {
                if (value.length >= 55) {
                    filter.partNumber = value.substring(0, 11);
                    filter.accoutingQuantity = parseInt(value.substring(39, 44));
                    filter.mdrLabel = value.substring(44, 48);
                    filter.qmeLabel = value.substring(39, 44);
                    setFilter({ ...filter }).then(() => {
                        onConfirm()
                    });
                }
            }
            else {
                //PackList
                const parts = [];
                if (value.length === 11) {
                    parts.push(value);

                } else {
                    if (value.length % 55 !== 0 && value.length % 56 !== 0) {
                        showMessageToastCustom(translate('general:warning'),
                            "QrCode formato Inválido.",
                            4000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    else {
                        if (value.length % 55 === 0) {
                            for (let i = 0, length = value.length; i < length; i += 55) {
                                const valueItem = value.substring(i, i + 55);
                                const partNumber = valueItem.substring(0, 11);
                                parts.push(partNumber);

                                const quantity = parseInt(valueItem.substring(38, 43));
                                const mdrLabel = valueItem.substring(43, 47);
                                const qmeLabel = valueItem.substring(47, 51);

                                onAddMasterCim({ partNumber, quantity, mdrLabel, qmeLabel });
                            }
                        } else {
                            if (value.length % 56 === 0) {
                                for (let i = 0, length = value.length; i < length; i += 56) {
                                    const valueItem = value.substring(i, i + 56);
                                    const partNumber = valueItem.substring(0, 11);
                                    parts.push(partNumber);
                                    const quantity = parseInt(valueItem.substring(39, 44));
                                    const mdrLabel = valueItem.substring(44, 48);
                                    const qmeLabel = valueItem.substring(48, 52);

                                    onAddMasterCim({ partNumber, quantity, mdrLabel, qmeLabel });
                                }
                            }
                        }
                    }
                }

                confirmationSmallParts(parts);
            }
        }
    }

    const onAddMasterCim = (data) => {
        const element = newObj(props.receipts?.find((r) => r.partNumberCode === data.partNumber));

        if (element) {
            var qtd = parseInt(data.quantity / (data.qmeLabel > 0 ? data.qmeLabel : 1) || 1);
            element.qtItems = (qtd > element.balance ? element.balance : qtd);
            element.qtStorage = (data.qmeLabel > 0 ? data.qmeLabel : 1);
            element.pallets = 1;
            element.quantityLocation = props.filter.truckKanban ? (qtd > element.balance ? element.balance : qtd) : null;

            props.addReceiptGroup(element);
            props.updateMassiveItem(element.id, false);
            props.updateVisualIndicator(element.id, false);
            var remainingQuantity = data.quantity - (element.qtStorage * element.qtItems * element.pallets);
            if (!props.filter.truckKanban && remainingQuantity > 0) {
                let newModel = {};
                Object.assign(newModel, element);
                // Marca o primeiro como falso;
                element.remainingBalance = false;
                //Cria um novo informando que é restante do material para o mesmo pallet
                newModel.remainingBalance = true;
                newModel.qtStorage = 1;
                newModel.pallets = 1;
                newModel.qtItems = remainingQuantity;
                props.addReceiptGroup(newModel);
            }

        }
    }

    const onConfirm = () => {
        if (validateInputsRequired("confirmLabel") && validateInputsRequired("printForm")) {
            filter.printer = props.user.printer
            props.receiveByLabel(filter, (response) => {
                if (response && response.receipt && !response.automaticSuccess) {
                    filter.confirmLabel = filter.automaticPrint;
                    setFilter({ ...filter });
                    setReceipt({ ...response.receipt })
                } else {
                    document.getElementById("qrCode").value = "";
                    filter.qrCode = "";
                    filter.confirmLabel = false;
                    setFilter({ ...filter });
                    setReceipt(null);
                    callbackSearch();
                }
            });
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };


    const validateShed = (item) => {
        if (getVision() !== VISIONS.Jeep && props.user.shed !== item.physicalConfirmationShed?.shed) {
            const msg = translate('message-validate-shed', 'physical-confirmation').replace('userShed', props.user.shed).replace('itemShed', item.physicalConfirmationShed?.shed);
            showMessageToastCustom(translate('general:warning'),
                msg,
                4000, 'mdi mdi-alert-circle-outline red-text');

        } else {
            props.createConfirmation(item, '', item.mdr);
            props.history.replace({
                pathname: `./confirmation`,
                state: {
                    goBack: true,
                },
                ...props
            });
        }
    };

    const isMassiveValid = () => {
        var massiveItems = receipts.filter(r => r.massiveReceiptIndicator && r.balance > 0);
        if (massiveItems.length === 0) {
            return showMessageToastCustom(translate('warning', 'general'), translate("no-items-selected-for-receipt", "general"), 8000, 'mdi mdi-alert-circle-outline red-text');
        }
        props.history.push({
            pathname: `./massiveReceipt`,
            state: { truckKanban: props.filter.truckKanban },
            ...props
        });
    }

    const isMasterCimValid = () => {
        const confirmations = []
        props.receiptsGroup.forEach((item) => {
            props.createConfirmation(item, '', item.mdr || '');
            item.dock = props.filter?.truckKanban ? "M01" : props.user.dock;
            item.shed = props.filter?.truckKanban ? item.shed : props.sheds.find((i) => i.id === props.user.shed).code;
            item.group = true;
            item.mdrType = item.mdr;
            item.mdrTypeOrigin = item.mdr;
            item.type = ENUMS.eTypeConfirmation.Confirmation.value;
            confirmations.push(item);
        });
        props.history.push({
            pathname: `./groupReceipt`,
            state: { receipts: confirmations, truckKanban: props.filter?.truckKanban }
        });
    }

    const renderItem = (item) => {
        return (
            <li
                onClick={() => validateShed(item)}
                key={`${item.id}`}
                className="collection-item"
                style={{ backgroundColor: 'white', color: 'black' }}
            >
                <div key={`${item.id}-div`}>
                    <div className="row" style={{ marginBottom: '0px', wordWrap: 'break-word' }}>
                        <div className="title black-text col s12" style={{ padding: '0px' }}>{item.partNumberCode}</div>
                        <div className="col s12 second-text-color" style={{ padding: '0px' }}>{item.partNumberDescription}</div>
                        <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:mvm')}: ${item.physicalConfirmation.mvmNumber}`}</small>
                        <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:qme')}: ${convertToSeparator(item.qme) || 0}`}</small>
                        <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('available', 'general')}: ${convertToSeparator(item.balance) || 0}`}</small>
                        <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:mdr')}: ${item.mdr || ''}`}</small>
                        <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:qt-receipt')}: ${item.accoutingQuantity - item.balance || 0}`}</small>
                        <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:note')}: ${item.invoice || ''}`}</small>
                        <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:shed')}: ${item.physicalConfirmationShed?.shed || ""}`} </small>
                    </div>
                </div>
            </li>
        )
    }


    return (
        <>
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '0px', paddingTop: '8px' }}>
                        <div className="row">
                            <div className={props.filter.truckKanban ? "input-field padding col s11" : "input-field padding col s7"}>
                                <ScannerCode className="mdi mdi-qrcode-scan posfix" onScanner={changePartNumberQrCode} />
                                <InputUI
                                    id="qrCode"
                                    name='qrCode'
                                    placeholder={translate('qrCode', 'truck-kanban')}
                                    type="text"
                                    onKeyDown={(e) => handleOnKeyDown(e)}
                                    onChange={(event) => changePartNumberQrCode(event.target?.value)}
                                    onBlur={(event) => { if (!checked) { changePartNumberQrCode(event.target.value); } }}
                                />
                            </div>
                            {!props.filter.truckKanban &&
                                <div className="input-field padding col s4">
                                    <span
                                        className="title sixth-text-color right"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <InputUI
                                            type="checkbox"
                                            onChange={() => {
                                                if (checked) {
                                                    setChecked(false);

                                                } else {
                                                    setChecked(true);
                                                }
                                            }}
                                            id="select"
                                            name="select"
                                            label="Etiqueta Latam"
                                            defaultChecked={checked}
                                        />
                                    </span>
                                </div>
                            }
                            {checked &&
                                <div id="printForm">
                                    <div className="input-field padding  col s12">
                                        <Select
                                            notOption
                                            required
                                            id="print"
                                            name="print"
                                            display="name"
                                            label={translate('print-type', 'physical-confirmation')}
                                            placeholder={translate('choose-one-option', 'general')}
                                            data={[
                                                { id: ENUMS.ePrintTypes.Logistics.value, text: translate(ENUMS.ePrintTypes.Logistics.text, 'physical-confirmation') },
                                                { id: ENUMS.ePrintTypes.Click.value, text: translate(ENUMS.ePrintTypes.Click.text, 'physical-confirmation') },
                                                { id: ENUMS.ePrintTypes.NotPrint.value, text: translate(ENUMS.ePrintTypes.NotPrint.text, 'physical-confirmation') },
                                            ]}
                                            change={onChange}
                                            defaultValue={filter.print}
                                        />
                                    </div>
                                </div>

                            }
                        </div>
                    </div>
                </div>
            </div>
            {
                props.receiptsGroup && props.receiptsGroup.length > 0 &&
                <div style={{ float: 'right', marginRight: '10px' }}>
                    <ButtonsInfo  {...props} receiptsGroup={props.receiptsGroup} clearReceiptsGroup={clearReceiptsGroup} />
                </div>
            }
            {
                !checked && receipts && receipts?.length > 0 &&
                (
                    <>

                        <div id='ReceiptListSmallPartsSearch' className="row" style={{ marginBottom: '5px' }}>
                            <ReceiptList {...props} id='ReceiptListSmallPartsSearchRow' packList="true" receipts={receipts} onSelectedItemChange={props.onSelectedItemChange} />
                        </div>
                        <div className="row" style={{ marginBottom: '5px' }}>
                            <div className="col s12 lefth">
                                {
                                    (receipts.filter(r => r.massiveReceiptIndicator).length > 0 ||
                                        receipts.filter(r => r.visualReceiptIndicator).length > 0 ||
                                        props.receiptsCimPallet.length > 0) && (!props.group || props.packList) &&
                                    (<Button onClick={isMassiveValid} full="true" text={translate('general:massive-receipt')} />)
                                }
                            </div>
                            <div className="row" style={{ marginBottom: '5px' }}>
                                <div className="col s12 lefth">
                                    {
                                        props.receiptsGroup && props.receiptsGroup.length > 0 && <Button full="true" onClick={isMasterCimValid} text="Recebimento Master CIM" />
                                    }
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
            {
                filter.confirmLabel && receipt &&
                <div className="card">
                    <div id="confirmLabel" className="card-content" style={{ padding: '3px', paddingTop: '10px' }}>
                        <div className='row'>
                            <div className="input-field no-padding col s12">
                                <span className="title col s12" style={{ color: 'red' }}>
                                    Foram encontradas as seguintes divergências, favor selecionar valores para armazenamento
                                </span>
                            </div>{
                                filter.mdrLabel !== receipt.mdr &&
                                <div className="input-field no-padding  col s12">
                                    <Select
                                        notOption
                                        required
                                        id="mdrLabel"
                                        name="mdrLabel"
                                        display="name"
                                        label="Selecione o MDR"
                                        placeholder={translate('choose-one-option', 'general')}
                                        data={[
                                            { id: filter.mdrLabel, text: `MDR Etiqueta Latam ${filter.mdrLabel}` },
                                            { id: receipt.mdr, text: `MDR Registro ${receipt.mdr}` },
                                        ]}
                                        change={onChange}
                                        defaultValue={filter.mdrLabel}
                                    />
                                </div>
                            }
                            {
                                filter.qmeLabel !== receipt.qme &&
                                <div className="input-field no-padding  col s12">
                                    <Select
                                        notOption
                                        required
                                        id="qmeLabel"
                                        name="qmeLabel"
                                        display="name"
                                        label="Selecione o QME"
                                        placeholder={translate('choose-one-option', 'general')}
                                        data={[
                                            { id: filter.qmeLabel, text: `QME Etiqueta Latam ${filter.qmeLabel}` },
                                            { id: receipt.qme, text: `QME Registro ${receipt.qme}` },
                                        ]}
                                        change={onChange}
                                        defaultValue={filter.qmeLabel}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                        <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                    </div>
                </div>
            }
            {
                receipt && !filter.confirmLabel &&
                <ul className="collection col s12" >
                    {renderItem(receipt)}
                </ul>
            }
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        filter: state.physicalConfirmationReducer.filter,
        user: state.userReducer.user,
        config: state.configReducer.config,
        sheds: state.configReducer.sheds,
        receipts: state.physicalConfirmationReducer.receipts,
        selectedTab: state.physicalConfirmationReducer.selectedTab,
        confirmation: state.physicalConfirmationReducer.confirmation,
        physicalConfirmation: state.physicalConfirmationReducer.physicalConfirmation,
        receiptsCimPallet: state.physicalConfirmationReducer.receiptsCimPallet,
        receiptsGroup: state.physicalConfirmationReducer.receiptsGroup
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        receiveByLabel: (filter, callback) => {
            dispatch(PhysicalConfirmationService.receiveByLabel(filter, callback));
        },
        createdTransmission: (transmission, callback) => {
            dispatch(PhysicalConfirmationService.createdTransmission(transmission, callback));
        },
        createConfirmation: (receiptItem, quantity, mdrType) => {
            dispatch(PhysicalConfirmationService.createConfirmation(receiptItem, quantity, mdrType));
        },
        searchPhysicalConfirmationService: (filter, callback) => {
            dispatch(PhysicalConfirmationService.search(filter, callback));
        },
        showLoading: () => {
            dispatch(startLoading());
        },
        hideLoading: () => {
            dispatch(endProcessing());
        },
        updateMassiveItem: (id, value) => {
            dispatch(PhysicalConfirmationService.updateMassiveIndicator(id, value));
        },
        updateVisualIndicator: (id, value) => {
            dispatch(PhysicalConfirmationService.updateVisualIndicator(id, value));
        },
        addReceiptGroup: (receipt) => {
            dispatch(PhysicalConfirmationService.addReceiptGroup(receipt));
        },
        resetReceipsGroup: () => {
            dispatch(PhysicalConfirmationService.resetReceipsGroup());
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SmallPartsSearch)));
